/**
 * Filtered content listing AJAX functionality
 */
(function($) {
    'use strict';

    // The original function is now wrapped in a jQuery ready function
    $(document).ready(function() {
        const $block = $('.block--filtered-content-listing');
        const debug = false; // Disable debug mode

        if ($block.length > 0) {
            const $search = $('.search-filter-form input[type=search]');
            const $form = $('.search-filter-form');
            const $content = $('.filtered-content-listing__content');
            const $section = $('.block--filtered-content-listing');
            const $selects = $form.find('select');
            const $searchButton = $('.search-form__submit');

            // Event listeners with delegation for efficiency
            $search.on('search', (e) => {
                e.preventDefault();
                if (!$(e.target).val()) $form.submit();
            });

            // Add event handler for search button click
            $searchButton.on('click', (e) => {
                e.preventDefault();
                filterContent(1);
            });

            $form.on('submit', (e) => {
                e.preventDefault();
                filterContent(1);
            });

            $selects.on('change', () => {
                $form.submit();
            });

            // Initial content load - adding a small delay to ensure DOM is ready
            setTimeout(() => {
                filterContent(1);
            }, 50);

            /**
             * Filters content based on form data and page number
             * @param {number} paged - Current page number
             */
            function filterContent(paged) {
                // The variables are now in scope since the function is defined inside the if block
                const postType = $section.data('post-type');
                const termID = $section.data('term-id');

                const formData = $form.serializeArray();

                const data = {
                    action: 'filter_content_listing',
                    nonce: filteredContentListing.nonce,
                    paged,
                    post_type: postType,
                    term_id: termID,
                };

                // Append form data to AJAX payload
                formData.forEach((item) => {
                    data[item.name] = item.value;
                });

                $.ajax({
                    url: filteredContentListing.ajax_url,
                    type: 'POST',
                    data,
                    beforeSend: () => {
                        $content.addClass('loading'); // Show loading state
                    },
                    success: (response) => {
                        if (response.success) {
                            $content.html(response.html);
                            
                            // Handle pagination similar to search-results.js
                            if (response.pagination) {
                                let $paginationContainer = $section.find('.search-results-pagination');
                                
                                // If no pagination container exists, create one
                                if ($paginationContainer.length === 0) {
                                    $paginationContainer = $('<div class="search-results-pagination"></div>');
                                    $content.after($paginationContainer);
                                } else {
                                    // Remove existing pagination to avoid duplicates
                                    $paginationContainer.remove();
                                    $paginationContainer = $('<div class="search-results-pagination"></div>');
                                    $content.after($paginationContainer);
                                }
                                
                                // Set the HTML from the server response
                                $paginationContainer.html(response.pagination);
                                
                                // Bind pagination events after content is updated
                                bindPaginationEvents();
                            } else {
                                // If no pagination in response, remove any existing pagination
                                $section.find('.search-results-pagination').remove();
                            }
                        } else {
                            $content.html('<p>Error loading content.</p>');
                        }
                    },
                    error: (xhr, status, error) => {
                        $content.html('<p>Request error.</p>');
                    },
                    complete: () => {
                        $content.removeClass('loading'); // Remove loading state
                    },
                });
            }

            /**
             * Binds click events to pagination links
             * Using event delegation to handle dynamically added pagination
             */
            function bindPaginationEvents() {
                // Remove any existing event listeners first to prevent duplicates
                $(document).off('click', '.search-results-pagination a');
                
                // Use event delegation to handle clicks on pagination links
                $(document).on('click', '.search-results-pagination a', function(e) {
                    e.preventDefault();
                    
                    let page;
                    const $this = $(this);
                    
                    // Try different strategies to get the page number
                    if ($this.hasClass('next') || $this.parent().hasClass('pagination__next')) {
                        // Next button
                        page = $this.data('page') || parseInt($this.attr('data-page'));
                    } else if ($this.hasClass('prev') || $this.parent().hasClass('pagination__prev')) {
                        // Prev button
                        page = $this.data('page') || parseInt($this.attr('data-page'));
                    } else {
                        // Regular page number
                        const $pageNumber = $this.closest('.pagination__page-number');
                        if ($pageNumber.length) {
                            page = parseInt($pageNumber.attr('data-pagination-page'));
                        } else {
                            // Try getting directly from link text
                            page = parseInt($this.text().trim());
                        }
                    }
                    
                    if (isNaN(page) || !page) {
                        return;
                    }
                    
                    filterContent(page);
                    
                    // Scroll back to top of results
                    $('html, body').animate({
                        scrollTop: $section.offset().top - 100
                    }, 300);
                });
            }
        }
    });
})(jQuery);
